import type { Metadata } from "next";
import { buildStorefrontMetadata, StorefrontPageView } from "../storefront-page-view";

interface StorefrontSubPageProps {
  params: Promise<{ slug: string; page: string }>;
}

export async function generateMetadata({ params }: StorefrontSubPageProps): Promise<Metadata> {
  const { slug, page } = await params;
  return buildStorefrontMetadata(slug, page);
}

/** About Us, Hours, Directions — any page the seller has added to their site. */
export default async function StorefrontSubPage({ params }: StorefrontSubPageProps) {
  const { slug, page } = await params;
  return <StorefrontPageView slug={slug} pageSlug={page} />;
}
